const showToast = ({ state, commit }, message) => {
  if (state.toast.show) commit('hideToast')

  setTimeout(() => {
    commit('showToast', {
      color: 'black',
      message,
      timeout: 3000
    })
  })
}

const showError = ({ state, commit }, message) => {
  if (state.toast.show) commit('hideToast')

  setTimeout(() => {
    commit('showToast', {
      color: 'error',
      message,
      timeout: 4000
    })
  })
}

const showSuccess = ({ state, commit }, message) => {
  if (state.toast.show) commit('hideToast')

  setTimeout(() => {
    commit('showToast', {
      color: 'success',
      message,
      timeout: 3000
    })
  })
}

const setGlobalTheme = ({ commit }, theme) => {
  // console.log('setGlobalTheme', theme)
  commit('setGlobalTheme', theme)
}

const osPrefersDark = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-color-scheme: dark)').matches

const resolveThemeMode = (mode) => {
  if (mode === 'dark') return true
  if (mode === 'light') return false
  return osPrefersDark()
}

// Sets the theme mode (os | light | dark) and applies the effective dark state
const setThemeMode = ({ commit }, mode) => {
  commit('setThemeMode', mode)
  commit('setGlobalTheme', resolveThemeMode(mode))
}

// Re-applies the current mode, used on app start and on OS preference changes
const applyTheme = ({ commit, state }) => {
  commit('setGlobalTheme', resolveThemeMode(state.themeMode))
}

export default {
  showToast,
  showError,
  showSuccess,
  setGlobalTheme,
  setThemeMode,
  applyTheme
}
